// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .dashboard_main_container {
  display: flex;
  min-height: 100vh;
}

.dashboard_link_side {
  width: 250px;
  background-color: #02337b;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  z-index: 1;
}

.dashboard_link_side a {
  display: block;
  color: white;
  padding: 15px;
  text-decoration: none;
  margin-bottom: 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.dashboard_link_side a:hover {
  background-color: #032250;
}

.dashboard_link_side a.active {
  background-color: #032250;
  color: white;
}

.dashboard_content_side {
  margin-left: 250px;
  flex: 1;

  overflow-y: auto;
  min-height: 100vh;
}

.hamburger {
  display: none;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1100;
  font-size: 24px;
  background: #333;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .dashboard_link_side {
    width: 200px;
  }
  .dashboard_content_side {
    margin-left: 200px;
  }
}

@media (max-width: 480px) {
  .dashboard_link_side {
    width: 250px;
    transform: translateX(-100%);
    position: fixed;
    top: 0;
    left: 0;
  }

  .dashboard_link_side.open {
    transform: translateX(0);
  }

  .dashboard_content_side {
    margin-left: 0;
    padding-top: 44px;
  }

  .hamburger {
    display: block;
    top: 0px;
    left: 0px;
  }
}

.content h1 {
  margin-top: 0;
  color: #333;
}

.content p {
  color: #666;
}
.outlet_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ededed;
  height: 70px;
}
.outlet_header h2 {
  margin-left: 100px;
}
.outlet_header_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-right: 50px;
  margin-left: 50px;
}
@media (max-width: 480px) {
  .outlet_header h2 {
    margin-left: 0px;
    font-size: 16px;
  }
  .outlet_header_icon {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-right: 0px;
    margin-left: 0px;
  }
}

.logout_container {
  position: relative;
  display: inline-block;
}

.email_text {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background 0.3s ease;
}

.email_text:hover {
  background: #f0f0f0;
}

.logout_button {
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  padding: 8px 12px;
  background: red;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  transition: background 0.3s;
}

.logout_button:hover {
  background: darkred;
} */

/* Root Variables */
:root {
  --primary-color: #1e40af;
  --primary-dark: #1e3a8a;
  --primary-light: #3b82f6;
  --secondary-color: #64748b;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --danger-color: #ef4444;
  --background-color: #f8fafc;
  --surface-color: #ffffff;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
  --radius: 8px;
  --sidebar-width: 280px;
  --header-height: 80px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Main Container */
.Dashboard_dashboard_main_container__-Mzs1 {
  display: flex;
  min-height: 100vh;
  background-color: var(--background-color);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

/* Mobile Header */
.Dashboard_mobile_header__SrV39 {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: var(--surface-color);
  border-bottom: 1px solid var(--border-color);
  z-index: 1000;
  align-items: center;
  padding: 0 16px;
  box-shadow: var(--shadow-sm);
}

.Dashboard_mobile_logo__ObEVt h3 {
  margin: 0;
  color: var(--primary-color);
  font-size: 18px;
  font-weight: 700;
}

.Dashboard_hamburger__hZS5d {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-primary);
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius);
  transition: var(--transition);
}

.Dashboard_hamburger__hZS5d:hover {
  background-color: var(--background-color);
}

/* Overlay for mobile */
.Dashboard_overlay__2vStM {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Sidebar */
.Dashboard_dashboard_link_side__Itbn3 {
  width: var(--sidebar-width);
  background: linear-gradient(
    180deg,
    var(--primary-color) 0%,
    var(--primary-dark) 100%
  );
  color: white;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  transition: var(--transition);
  z-index: 1000;
  box-shadow: var(--shadow-lg);
}

.Dashboard_sidebar_header__NgBRE {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.Dashboard_logo_container__IBJE4 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Dashboard_logo_icon__T4qkL {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  backdrop-filter: blur(10px);
}

.Dashboard_logo_text__7vF5i {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.Dashboard_sidebar_nav__r8qvo {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Dashboard_nav_link__qsJ0H {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.8);
  padding: 12px 20px;
  text-decoration: none;
  margin: 0 12px 4px;
  border-radius: var(--radius);
  transition: var(--transition);
  font-weight: 500;
  position: relative;
}

.Dashboard_nav_link__qsJ0H:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateX(4px);
}

.Dashboard_nav_link__qsJ0H.Dashboard_active__iHh2V {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 600;
}

.Dashboard_nav_link__qsJ0H.Dashboard_active__iHh2V::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background-color: white;
  border-radius: 0 2px 2px 0;
}

.Dashboard_nav_link__qsJ0H svg {
  font-size: 20px;
  flex-shrink: 0;
}

.Dashboard_nav_link__qsJ0H span {
  font-size: 14px;
}

/* Main Content */
.Dashboard_dashboard_content_side__L4qGE {
  margin-left: var(--sidebar-width);
  flex: 1 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.Dashboard_outlet_header__L9n-5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--surface-color);
  height: var(--header-height);
  padding: 0 32px;
  border-bottom: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  position: sticky;
  top: 0;
  z-index: 100;
}

.Dashboard_header_left__p8PLR {
  display: flex;
  align-items: center;
}

.Dashboard_department_title__7VC-d {
  margin: 0;
  color: var(--text-primary);
  font-size: 24px;
  font-weight: 700;
}

.Dashboard_header_right__pzxEu {
  display: flex;
  align-items: center;
  gap: 24px;
}

/* Notification */
.Dashboard_notification_container__Uz-Iy {
  position: relative;
}

.Dashboard_notification_btn__WFKBu {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 20px;
  cursor: pointer;
  padding: 12px;
  border-radius: 50%;
  transition: var(--transition);
  position: relative;
}

.Dashboard_notification_btn__WFKBu:hover {
  background-color: var(--background-color);
  color: var(--primary-color);
}

.Dashboard_notification_badge__8fXwh {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: var(--danger-color);
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

/* User Menu */
.Dashboard_user_menu__mh1iq {
  position: relative;
}

.Dashboard_user_info__mwu28 {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: var(--radius);
  transition: var(--transition);
}

.Dashboard_user_info__mwu28:hover {
  background-color: var(--background-color);
}

.Dashboard_user_avatar__rqNu1 {
  width: 40px;
  height: 40px;
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--primary-light)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.Dashboard_user_details__ivASe {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.Dashboard_user_email__TShWo {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.2;
}

.Dashboard_user_role__Q1RFf {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.2;
}

.Dashboard_dropdown_icon__xqwpS {
  font-size: 12px;
  color: var(--text-secondary);
  transition: var(--transition);
}

.Dashboard_dropdown_icon__xqwpS.Dashboard_rotated__tYoFD {
  transform: rotate(180deg);
}

.Dashboard_dropdown_menu__RtpA\\+ {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  padding: 8px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 8px;
}

.Dashboard_logout_button__XRijz {
  width: 100%;
  background-color: var(--danger-color);
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
}

.Dashboard_logout_button__XRijz:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}

/* Main Content Area */
.Dashboard_main_content__p4zPh {
  flex: 1 1;
  padding: 32px;
  overflow-y: auto;
}

/* Responsive Design */
@media (max-width: 1024px) {
  :root {
    --sidebar-width: 260px;
  }

  .Dashboard_outlet_header__L9n-5 {
    padding: 0 24px;
  }

  .Dashboard_main_content__p4zPh {
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .Dashboard_mobile_header__SrV39 {
    display: flex;
  }

  .Dashboard_dashboard_link_side__Itbn3 {
    width: var(--sidebar-width);
    transform: translateX(-100%);
    position: fixed;
    top: 0;
    left: 0;
  }

  .Dashboard_dashboard_link_side__Itbn3.Dashboard_open__1IGB2 {
    transform: translateX(0);
  }

  .Dashboard_overlay__2vStM {
    display: block;
  }

  .Dashboard_dashboard_content_side__L4qGE {
    margin-left: 0;
    padding-top: 60px;
  }

  .Dashboard_hamburger__hZS5d {
    display: flex;
  }

  .Dashboard_outlet_header__L9n-5 {
    padding: 0 16px;
    height: 70px;
  }

  .Dashboard_department_title__7VC-d {
    font-size: 20px;
  }

  .Dashboard_header_right__pzxEu {
    gap: 16px;
  }

  .Dashboard_user_details__ivASe {
    display: none;
  }

  .Dashboard_main_content__p4zPh {
    padding: 20px 16px;
  }
}

@media (max-width: 480px) {
  .Dashboard_department_title__7VC-d {
    font-size: 18px;
  }

  .Dashboard_header_right__pzxEu {
    gap: 12px;
  }

  .Dashboard_notification_btn__WFKBu {
    padding: 8px;
  }

  .Dashboard_user_info__mwu28 {
    padding: 4px 8px;
  }

  .Dashboard_main_content__p4zPh {
    padding: 16px 12px;
  }
}

/* Scrollbar Styling */
.Dashboard_dashboard_link_side__Itbn3::-webkit-scrollbar {
  width: 4px;
}

.Dashboard_dashboard_link_side__Itbn3::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.Dashboard_dashboard_link_side__Itbn3::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.Dashboard_dashboard_link_side__Itbn3::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Animation for sidebar */
@keyframes Dashboard_slideIn__ITCus {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.Dashboard_dashboard_link_side__Itbn3.Dashboard_open__1IGB2 {
  animation: Dashboard_slideIn__ITCus 0.3s ease-out;
}

/* Focus states for accessibility */
.Dashboard_nav_link__qsJ0H:focus,
.Dashboard_notification_btn__WFKBu:focus,
.Dashboard_user_info__mwu28:focus,
.Dashboard_logout_button__XRijz:focus,
.Dashboard_hamburger__hZS5d:focus {
  outline: 2px solid var(--primary-light);
  outline-offset: 2px;
}

/* Loading states */
.Dashboard_nav_link__qsJ0H:active {
  transform: translateX(2px);
}

/* Hover effects */
.Dashboard_nav_link__qsJ0H:hover svg {
  transform: scale(1.1);
}

.Dashboard_user_avatar__rqNu1:hover {
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/Dashboard.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwKG;;AAEH,mBAAmB;AACnB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;EAC1C,6EAA6E;EAC7E;mCACiC;EACjC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,yCAAyC;EACzC;cACY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;EAC5B,eAAe;EACf,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iDAAgC;AAClC;;AAEA,mCAAmC;AACnC;;;;;EAKE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* .dashboard_main_container {\n  display: flex;\n  min-height: 100vh;\n}\n\n.dashboard_link_side {\n  width: 250px;\n  background-color: #02337b;\n  color: white;\n  padding: 15px;\n  box-sizing: border-box;\n  position: fixed;\n  height: 100vh;\n  overflow-y: auto;\n  transition: transform 0.3s ease-in-out;\n  z-index: 1;\n}\n\n.dashboard_link_side a {\n  display: block;\n  color: white;\n  padding: 15px;\n  text-decoration: none;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.dashboard_link_side a:hover {\n  background-color: #032250;\n}\n\n.dashboard_link_side a.active {\n  background-color: #032250;\n  color: white;\n}\n\n.dashboard_content_side {\n  margin-left: 250px;\n  flex: 1;\n\n  overflow-y: auto;\n  min-height: 100vh;\n}\n\n.hamburger {\n  display: none;\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  z-index: 1100;\n  font-size: 24px;\n  background: #333;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .dashboard_link_side {\n    width: 200px;\n  }\n  .dashboard_content_side {\n    margin-left: 200px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard_link_side {\n    width: 250px;\n    transform: translateX(-100%);\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n\n  .dashboard_link_side.open {\n    transform: translateX(0);\n  }\n\n  .dashboard_content_side {\n    margin-left: 0;\n    padding-top: 44px;\n  }\n\n  .hamburger {\n    display: block;\n    top: 0px;\n    left: 0px;\n  }\n}\n\n.content h1 {\n  margin-top: 0;\n  color: #333;\n}\n\n.content p {\n  color: #666;\n}\n.outlet_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ededed;\n  height: 70px;\n}\n.outlet_header h2 {\n  margin-left: 100px;\n}\n.outlet_header_icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n  margin-right: 50px;\n  margin-left: 50px;\n}\n@media (max-width: 480px) {\n  .outlet_header h2 {\n    margin-left: 0px;\n    font-size: 16px;\n  }\n  .outlet_header_icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n}\n\n.logout_container {\n  position: relative;\n  display: inline-block;\n}\n\n.email_text {\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n\n.email_text:hover {\n  background: #f0f0f0;\n}\n\n.logout_button {\n  position: absolute;\n  top: 30px;\n  left: 0;\n  width: 100%;\n  padding: 8px 12px;\n  background: red;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n  transition: background 0.3s;\n}\n\n.logout_button:hover {\n  background: darkred;\n} */\n\n/* Root Variables */\n:root {\n  --primary-color: #1e40af;\n  --primary-dark: #1e3a8a;\n  --primary-light: #3b82f6;\n  --secondary-color: #64748b;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --danger-color: #ef4444;\n  --background-color: #f8fafc;\n  --surface-color: #ffffff;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --border-color: #e2e8f0;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1),\n    0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --radius: 8px;\n  --sidebar-width: 280px;\n  --header-height: 80px;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Main Container */\n.dashboard_main_container {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--background-color);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n}\n\n/* Mobile Header */\n.mobile_header {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background-color: var(--surface-color);\n  border-bottom: 1px solid var(--border-color);\n  z-index: 1000;\n  align-items: center;\n  padding: 0 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.mobile_logo h3 {\n  margin: 0;\n  color: var(--primary-color);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.hamburger {\n  display: none;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: var(--radius);\n  transition: var(--transition);\n}\n\n.hamburger:hover {\n  background-color: var(--background-color);\n}\n\n/* Overlay for mobile */\n.overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n/* Sidebar */\n.dashboard_link_side {\n  width: var(--sidebar-width);\n  background: linear-gradient(\n    180deg,\n    var(--primary-color) 0%,\n    var(--primary-dark) 100%\n  );\n  color: white;\n  position: fixed;\n  height: 100vh;\n  overflow-y: auto;\n  transition: var(--transition);\n  z-index: 1000;\n  box-shadow: var(--shadow-lg);\n}\n\n.sidebar_header {\n  padding: 24px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logo_container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logo_icon {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: var(--radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.logo_text {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n}\n\n.sidebar_nav {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.nav_link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  padding: 12px 20px;\n  text-decoration: none;\n  margin: 0 12px 4px;\n  border-radius: var(--radius);\n  transition: var(--transition);\n  font-weight: 500;\n  position: relative;\n}\n\n.nav_link:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  transform: translateX(4px);\n}\n\n.nav_link.active {\n  background-color: rgba(255, 255, 255, 0.15);\n  color: white;\n  font-weight: 600;\n}\n\n.nav_link.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 24px;\n  background-color: white;\n  border-radius: 0 2px 2px 0;\n}\n\n.nav_link svg {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.nav_link span {\n  font-size: 14px;\n}\n\n/* Main Content */\n.dashboard_content_side {\n  margin-left: var(--sidebar-width);\n  flex: 1;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.outlet_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--surface-color);\n  height: var(--header-height);\n  padding: 0 32px;\n  border-bottom: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.header_left {\n  display: flex;\n  align-items: center;\n}\n\n.department_title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.header_right {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n/* Notification */\n.notification_container {\n  position: relative;\n}\n\n.notification_btn {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 20px;\n  cursor: pointer;\n  padding: 12px;\n  border-radius: 50%;\n  transition: var(--transition);\n  position: relative;\n}\n\n.notification_btn:hover {\n  background-color: var(--background-color);\n  color: var(--primary-color);\n}\n\n.notification_badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: var(--danger-color);\n  color: white;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 16px;\n  text-align: center;\n}\n\n/* User Menu */\n.user_menu {\n  position: relative;\n}\n\n.user_info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  transition: var(--transition);\n}\n\n.user_info:hover {\n  background-color: var(--background-color);\n}\n\n.user_avatar {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(\n    135deg,\n    var(--primary-color),\n    var(--primary-light)\n  );\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 16px;\n}\n\n.user_details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.user_email {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n\n.user_role {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.2;\n}\n\n.dropdown_icon {\n  font-size: 12px;\n  color: var(--text-secondary);\n  transition: var(--transition);\n}\n\n.dropdown_icon.rotated {\n  transform: rotate(180deg);\n}\n\n.dropdown_menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: var(--surface-color);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n  padding: 8px;\n  min-width: 160px;\n  z-index: 1000;\n  margin-top: 8px;\n}\n\n.logout_button {\n  width: 100%;\n  background-color: var(--danger-color);\n  color: white;\n  border: none;\n  padding: 12px 16px;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n}\n\n.logout_button:hover {\n  background-color: #dc2626;\n  transform: translateY(-1px);\n}\n\n/* Main Content Area */\n.main_content {\n  flex: 1;\n  padding: 32px;\n  overflow-y: auto;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  :root {\n    --sidebar-width: 260px;\n  }\n\n  .outlet_header {\n    padding: 0 24px;\n  }\n\n  .main_content {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .mobile_header {\n    display: flex;\n  }\n\n  .dashboard_link_side {\n    width: var(--sidebar-width);\n    transform: translateX(-100%);\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n\n  .dashboard_link_side.open {\n    transform: translateX(0);\n  }\n\n  .overlay {\n    display: block;\n  }\n\n  .dashboard_content_side {\n    margin-left: 0;\n    padding-top: 60px;\n  }\n\n  .hamburger {\n    display: flex;\n  }\n\n  .outlet_header {\n    padding: 0 16px;\n    height: 70px;\n  }\n\n  .department_title {\n    font-size: 20px;\n  }\n\n  .header_right {\n    gap: 16px;\n  }\n\n  .user_details {\n    display: none;\n  }\n\n  .main_content {\n    padding: 20px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .department_title {\n    font-size: 18px;\n  }\n\n  .header_right {\n    gap: 12px;\n  }\n\n  .notification_btn {\n    padding: 8px;\n  }\n\n  .user_info {\n    padding: 4px 8px;\n  }\n\n  .main_content {\n    padding: 16px 12px;\n  }\n}\n\n/* Scrollbar Styling */\n.dashboard_link_side::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dashboard_link_side::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dashboard_link_side::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.dashboard_link_side::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Animation for sidebar */\n@keyframes slideIn {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.dashboard_link_side.open {\n  animation: slideIn 0.3s ease-out;\n}\n\n/* Focus states for accessibility */\n.nav_link:focus,\n.notification_btn:focus,\n.user_info:focus,\n.logout_button:focus,\n.hamburger:focus {\n  outline: 2px solid var(--primary-light);\n  outline-offset: 2px;\n}\n\n/* Loading states */\n.nav_link:active {\n  transform: translateX(2px);\n}\n\n/* Hover effects */\n.nav_link:hover svg {\n  transform: scale(1.1);\n}\n\n.user_avatar:hover {\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard_main_container": `Dashboard_dashboard_main_container__-Mzs1`,
	"mobile_header": `Dashboard_mobile_header__SrV39`,
	"mobile_logo": `Dashboard_mobile_logo__ObEVt`,
	"hamburger": `Dashboard_hamburger__hZS5d`,
	"overlay": `Dashboard_overlay__2vStM`,
	"dashboard_link_side": `Dashboard_dashboard_link_side__Itbn3`,
	"sidebar_header": `Dashboard_sidebar_header__NgBRE`,
	"logo_container": `Dashboard_logo_container__IBJE4`,
	"logo_icon": `Dashboard_logo_icon__T4qkL`,
	"logo_text": `Dashboard_logo_text__7vF5i`,
	"sidebar_nav": `Dashboard_sidebar_nav__r8qvo`,
	"nav_link": `Dashboard_nav_link__qsJ0H`,
	"active": `Dashboard_active__iHh2V`,
	"dashboard_content_side": `Dashboard_dashboard_content_side__L4qGE`,
	"outlet_header": `Dashboard_outlet_header__L9n-5`,
	"header_left": `Dashboard_header_left__p8PLR`,
	"department_title": `Dashboard_department_title__7VC-d`,
	"header_right": `Dashboard_header_right__pzxEu`,
	"notification_container": `Dashboard_notification_container__Uz-Iy`,
	"notification_btn": `Dashboard_notification_btn__WFKBu`,
	"notification_badge": `Dashboard_notification_badge__8fXwh`,
	"user_menu": `Dashboard_user_menu__mh1iq`,
	"user_info": `Dashboard_user_info__mwu28`,
	"user_avatar": `Dashboard_user_avatar__rqNu1`,
	"user_details": `Dashboard_user_details__ivASe`,
	"user_email": `Dashboard_user_email__TShWo`,
	"user_role": `Dashboard_user_role__Q1RFf`,
	"dropdown_icon": `Dashboard_dropdown_icon__xqwpS`,
	"rotated": `Dashboard_rotated__tYoFD`,
	"dropdown_menu": `Dashboard_dropdown_menu__RtpA+`,
	"logout_button": `Dashboard_logout_button__XRijz`,
	"main_content": `Dashboard_main_content__p4zPh`,
	"open": `Dashboard_open__1IGB2`,
	"slideIn": `Dashboard_slideIn__ITCus`
};
export default ___CSS_LOADER_EXPORT___;
